import _extends from '@babel/runtime/helpers/extends';
import React__default, { forwardRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { getIntentClass } from '../../commonClasses.js';
import Label from './Label.js';
import FormHelperText from './FormHelperText.js';

const FORM_GROUP_PROPS = {
  intent: ['default', 'danger', 'success']
};
const BASE_CLASS = 'nui-form-group';
const Classes = {
  BASE: BASE_CLASS,
  NO_MARGIN: `${BASE_CLASS}--no-margin`
};
const formGroupPropTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  intent: PropTypes.oneOf(FORM_GROUP_PROPS.intent),
  /** Do not add vertical margin (useful for horizontal forms) */
  noMargin: PropTypes.bool
};
const FormGroup = /*#__PURE__*/forwardRef(({
  children,
  className = '',
  noMargin,
  intent = 'default',
  ...restProps
}, ref) => {
  const intentClass = getIntentClass(intent);
  const classes = cx(Classes.BASE, {
    [Classes.NO_MARGIN]: noMargin
  }, intentClass, className);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classes,
    ref: ref
  }, restProps), children);
});
FormGroup.propTypes = formGroupPropTypes;
FormGroup.displayName = 'NuiFormGroup';
var FormGroup$1 = Object.assign(FormGroup, {
  Label,
  HelperText: FormHelperText
});

export { FORM_GROUP_PROPS, FormGroup$1 as default };
